import { createContext } from 'react';
import initialUIDPrefixer from './initialUIDPrefixer';

const UIDContext = createContext(initialUIDPrefixer);

export type Prefixer = (suffix: string) => string;

export default UIDContext;
